function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 613 139",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logos"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    d: "M307.161,136.616L290.553,136.616L200.397,32.819L200.397,136.616L182.208,136.616L182.208,1.779L197.629,1.779L288.971,106.169L288.971,1.779L307.161,1.779L307.161,136.616",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    d: "M434.894,1.779L458.223,1.779L408.204,65.441L408.204,136.616L388.829,136.616L388.829,65.244L338.808,1.779L362.137,1.779L398.319,48.241L434.894,1.779",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    d: "M555.091,66.825L612.624,136.616L589.295,136.616L543.426,80.862L496.965,136.616L473.438,136.616L531.564,66.825L477.59,1.779L501.118,1.779L543.426,53.184L585.539,1.779L608.868,1.779L555.091,66.825",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    d: "M72.3,0C28.607,0 -0.06,31.831 -0.06,69.198C-0.06,98.556 17.912,125.35 47.799,134.788C51.906,136.084 56.234,137.056 60.776,137.658C58.952,132.288 55.679,129.451 52.251,126.48C49.337,123.954 46.342,121.348 44.282,117.305C43.959,116.673 43.656,116.011 43.383,115.303C42.959,114.198 42.64,113.102 42.376,112.008C28.577,102.977 19.908,87.546 19.908,69.198C19.908,39.542 42.248,17.794 72.3,17.794C102.549,17.794 124.891,39.542 124.891,69.198C124.891,81.893 120.734,93.186 113.59,101.936C114.566,109.407 114.091,117.007 110.557,123.925C109.112,126.753 107.199,129.349 104.835,131.713C130.362,120.304 144.86,95.703 144.86,69.198C144.86,31.633 116.785,0 72.3,0",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    d: "M80.078,102.023C78.101,97.539 76.057,92.902 74.846,87.44C73.537,81.543 73.135,76.215 73.433,71.39C65.959,77.189 58.276,85.439 62.917,101.184L62.956,101.33C64.239,106.655 66.723,110.605 69.126,114.424C70.407,116.46 71.668,118.471 72.692,120.593C75.007,125.394 76.093,130.775 73.36,138.362C73.321,138.472 73.275,138.585 73.234,138.695C73.347,138.581 73.448,138.472 73.559,138.358C81.01,130.773 83.996,124.788 84.517,119.331C85.084,113.402 82.754,108.092 80.078,102.023",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24",
    d: "M65.657,120.221C65.152,119.376 64.611,118.515 64.048,117.619C63.878,117.349 63.703,117.068 63.53,116.792C61.139,112.975 58.556,108.632 57.141,102.809C55.976,98.835 55.483,95.246 55.491,91.984C48.19,98.272 45.994,105.376 48.983,113.149C49.457,114.381 50.063,115.444 50.755,116.422C52.216,118.489 54.097,120.14 56.181,121.946C60.34,125.551 64.991,129.605 67.104,137.956C67.566,136.879 67.933,135.863 68.216,134.9C70.007,128.777 68.363,124.743 65.657,120.221",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    d: "M101.295,80.054C99.724,75.693 98.369,71.926 97.628,68.667C95.252,58.214 96.777,48.566 98.715,41.835C94.206,44.552 90.481,47.655 87.543,51.14C85.02,54.134 83.077,57.408 81.718,60.959C80.269,64.742 79.479,68.837 79.358,73.242C79.247,77.284 79.692,81.584 80.703,86.141C81.094,87.903 81.597,89.596 82.164,91.24C83.169,94.151 84.38,96.907 85.568,99.602C87.053,102.971 88.514,106.296 89.485,109.733C90.21,112.295 90.655,114.922 90.635,117.675C90.613,120.593 90.057,123.655 88.744,126.938C87.406,130.283 85.273,133.86 82.102,137.748C83.449,137.32 84.737,136.864 85.979,136.387C91.078,134.427 95.307,132.046 98.635,129.256C101.489,126.864 103.691,124.177 105.214,121.195C107.361,116.992 108.137,112.41 108.053,107.694C107.887,98.371 104.346,88.525 101.295,80.054",
    style: {
      fill: "white"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bcef494f29891923cfbfb4e9c36bd348.svg";
export { ForwardRef as ReactComponent };